import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthenticationContainer } from 'entities/Authentication';
import { LanguageSwitch } from 'features/SwitchLanguage';
import { getTelegramBotUrl } from 'shared/consts/telegram';
import { Flex, Typography } from 'shared/_ui';

import styles from './styles.module.scss';

const SUPPORT_EMAIL = 'support@irs-lab.fr';

export const RussiaExistingAccountPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <AuthenticationContainer
      layoutControls={<LanguageSwitch />}
      title={t('landing.russia.existingAccount.title')}
    >
      <Flex direction="column" spacing={24} className={styles.wrapper}>
        <div className={styles.notice}>
          <Typography.Text type="secondary" className={styles.text}>
            {t('landing.russia.existingAccount.description')}
          </Typography.Text>
        </div>

        <Flex direction="column" spacing={12}>
          <a
            className={styles.primaryAction}
            data-gtm-event-name="click_ExistingAccountTelegram"
            href={getTelegramBotUrl()}
            target="_blank"
            rel="noreferrer"
          >
            {t('landing.russia.existingAccount.telegramButton')}
          </a>
          <Typography.Text type="secondary" className={styles.supportText}>
            {t('landing.russia.existingAccount.support')}{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </Typography.Text>
        </Flex>
      </Flex>
    </AuthenticationContainer>
  );
};
